import { TimeInput } from '@mantine/dates';
import dayjs from 'dayjs';
import { useIsMobile } from 'src/utils/UseMediaQuery';
import Button from '../atoms/Button';
import Checkbox from '../atoms/Checkbox';
import css from './HoursSelector.module.scss';

export default function HoursSelector({
  hours,
  updateDay,
  updateHour,
  userCanUpdate,
  addSubDay,
  removeSubDay,
}) {
  const isMobile = useIsMobile();

  return (
    <div className={css['grid']}>
      <span></span>
      <span className={css.title}>Opens</span>
      <span className={css.title}>Closes</span>
      <span></span>
      {hours.map((hour, index) => (
        <>
          {/* don't show checkbox+label if the row is an additional hour the a day */}
          {hour.isSub ? (
            <span></span>
          ) : (
            <Checkbox
              label={hour.day.slice(0, 3)}
              value={!hour.isClosed}
              onChange={() => updateDay(index)}
              disabled={!userCanUpdate}
              name={hour + index}
            />
          )}

          <TimeInput
            value={
              dayjs(hour.openTime).isValid('hh:mm a')
                ? dayjs(hour.openTime, 'hh:mm a').format('HH:mm')
                : dayjs(hour.openTime, 'HH:mm').format('HH:mm')
            }
            onChange={(event) => updateHour(event.target.value, index, 'openTime')}
            disabled={!userCanUpdate || hour.isClosed}
          />
          <TimeInput
            // the value format should be updated to match 24-hours format
            value={
              dayjs(hour.closeTime).isValid('hh:mm a')
                ? dayjs(hour.closeTime, 'hh:mm a').format('HH:mm')
                : dayjs(hour.closeTime, 'HH:mm').format('HH:mm')
            }
            onChange={(event) => updateHour(event.target.value, index, 'closeTime')}
            disabled={!userCanUpdate || hour.isClosed}
          />

          {hour.isSub ? (
            <Button
              iconLeft="fad fa-minus"
              size="s"
              variant="secondary"
              color="gray"
              action={() => removeSubDay(index)}
            />
          ) : !hour.isClosed ? (
            // if the current row is an additional hour in a day, the icon for it should be a "minus" sign
            // action: should add a new row for the day
            <Button
              iconLeft="fad fa-plus"
              size="s"
              variant="secondary"
              color="gray"
              action={() => addSubDay(index, hour.day)}
            />
          ) : (
            <span></span>
          )}
        </>
      ))}
    </div>
  );
}
